import { type ChartingNoncomplianceState } from "@src/appV2/Charting/api/schema";
import { useGetChartingNoncompliances } from "@src/appV2/Charting/api/useGetChartingNoncompliances";

const ACTIVE_CHARTING_NONCOMPLIANCE_STATES: ChartingNoncomplianceState[] = [
  "recalled",
  "review",
  "violation",
];

interface UseWorkerHasActiveChartingNoncomplianceParams {
  workplaceId: string;
  workerId: string;
  enabled?: boolean;
}

/**
 * Checks whether a worker has an active charting noncompliance (recalled, review, or violation)
 * at a specific workplace. When true, the workplace should be allowed to chat with the worker
 * even if the worker is blocked/DNR'd, because they were recalled for charting compliance.
 */
export function useWorkerHasActiveChartingNoncompliance(
  params: UseWorkerHasActiveChartingNoncomplianceParams
) {
  const { workplaceId, workerId, enabled = true } = params;

  const { data, isLoading, isSuccess } = useGetChartingNoncompliances(
    {
      workplaceId,
      workerId,
      state: ACTIVE_CHARTING_NONCOMPLIANCE_STATES,
    },
    {
      enabled: enabled && Boolean(workplaceId) && Boolean(workerId),
    }
  );

  const hasActiveChartingNoncompliance = !isLoading && isSuccess && (data?.data.length ?? 0) > 0;

  return {
    hasActiveChartingNoncompliance,
    isLoading,
  };
}
